const ZertoFeatureCard = ({ image, title, description }) => {
  return (
    <div className="flex flex-col items-start gap-5 self-stretch md:max-w-[360px] md:gap-6">
      <div>
        <img src={image} alt="" className="w-9 h-9 md:w-12 md:h-12" />
      </div>

      <div className="flex flex-col items-start gap-3 md:gap-2 self-stretch">
        <p className="text-grey-09 text-[18px] leading-[32px] md:text-[24px] md:leading-[32px] font-google font-medium">
          {title}
        </p>
        <p className="text-grey-05 text-[14px] leading-[24px] md:text-[16px] md:leading-[24px] font-inter font-normal">
          {description}
        </p>
      </div>
    </div>
  );
};
export default ZertoFeatureCard;
